import React from "react";

const LOGO_SRC = "/eagle.png";

export const Logo = ({ size = 40, withWordmark = true, hideWordmarkOnMobile = false, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="tp-logo">
    <img
      src={LOGO_SRC}
      alt="TP Agency"
      style={{ height: size }}
      className="w-auto shrink-0 object-contain drop-shadow-[0_4px_14px_rgba(37,99,235,0.45)]"
      loading="eager"
      decoding="async"
    />
    {withWordmark && (
      <div className={`leading-tight ${hideWordmarkOnMobile ? "hidden sm:block" : ""}`}>
        <div className="font-display font-extrabold text-white text-[17px]">TP Agency</div>
        <div className="text-[9px] tracking-[0.22em] text-cyan-300/80 font-medium">RECOVER · AUTOMATE</div>
      </div>
    )}
  </div>
);
